import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { allIncidentReports } from '../../services/incidentReports';
import { handleError } from '../../utilities/errorHandler';
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import CustomLoader from '../shared/CustomLoader';
import IncidentReportsTable from '../tables/IncidentReportsTable';

const IncidentReports = () => {
    const [ isLoading, setIsLoading ] = useState(false);
    const [ incidentReports, setIncidentReports ] = useState([]);
    const [ message, setMessage ] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const getIncidentReports = useCallback(async () => {
        setIsLoading(true);

        try {
            const response = await allIncidentReports();
            if (response.status === 200){
                setIncidentReports(response.data)
            }
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getIncidentReports();
    }, []);
  return (
    <Container fluid>

        <PageTitle title='Incident Reports' />

        <Message
            message={message.text}
            show={message.show}
            variant={message.variant}
            handleClose={handleCloseMessage}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <IncidentReportsTable
                    incidentReports={incidentReports}
                />
            )
        }
    </Container>
  )
}

export default IncidentReports